import React from 'react';
import IframeWidget from "./IframeWidget";
import AppConfig from "../services/AppConfig";
import {MenuProductViewType} from "../services/Api/types";

interface Props {
    to: string;
    sectionMargin: number;
    isFirstElement: boolean;
    children: React.ReactNode;
    productsViewType: MenuProductViewType;
}

const ScrollMenuTo = ({to, sectionMargin, isFirstElement, children, productsViewType}: Props) => {
    let innerSectionMargin = sectionMargin;

    if (AppConfig.isWidget()) {
        innerSectionMargin += 60;
    }

    function scrollTo(elementId: any, e: any) {
        e.preventDefault();

        const element = document.getElementById(elementId);
        if (!element) return;

        const rect = element.getBoundingClientRect();
        const sectionTopSpace = productsViewType === MenuProductViewType.HORIZONTAL ? 24 : 16;

        const scrollToValue = rect.top + window.scrollY - innerSectionMargin - sectionTopSpace + 2;


        if (AppConfig.isWidget()) {
            IframeWidget.scrollTo(scrollToValue);
        } else {
            window.scrollTo({
                top: scrollToValue,
                left: isFirstElement ? 0 : undefined,
                behavior: "smooth"
            });
        }
    }

    return (
        <a href="#" className="nav-link" onClick={(e) => scrollTo(to, e)}>
            {children}
        </a>
    )
}
export default ScrollMenuTo;

